import { Forms } from 'models/conent';
import { useState, useEffect } from 'react'
import style from '../styles/Content.module.scss'
import BgAnimations from './bganimations';
import { useRouter } from 'next/router';
import { translate } from 'utils/translate';
import { formatRules, requiredRule } from 'utils/validation';
import { useLocale } from '@components/Contexts/LocaleContext';
interface IProps {
    contents: Forms;
    register?: any;
    disabled?: boolean;
}

const Input = ({ contents, register, disabled = false }: IProps) => {
    const [content, setContent] = useState(<></>)
    const {lang} = useLocale();

    useEffect(() => {
        switch (contents?.inputType) {
            case 'button':
                setContent(
                <>
                    <div className="flex justify-center py-6 md:py-3">
                        <button style={{ marginTop: '20px' }} type="submit"
                                className="btn custom-blue-button disabled:bg-neutral-300" 
                                disabled={disabled}>
                            {translate(contents, 'label', lang)}
                        </button>
                    </div>
                </>)
                break;
            case 'checkbox':
                setContent(
                    <div className="my-6 md:my-5 text-left">
                        <input 
                            type="checkbox" 
                            className="mt-4 form-radio xl:h-4 xl:w-4"
                            name={contents.name}
                            {...register(
                                contents.name == 'eBudget' ? 'eBudget' :
                                contents.name == 'eClaim' ? 'eClaim' :
                                contents.name == 'eService' ? 'eService' :
                                contents.name == 'fixAsset' ? 'fixAsset' :
                                contents.name == 'eBilling' ? 'eBilling' : 'none', {
                                    ...requiredRule(contents.required, translate(contents, 'label', lang), lang),
                                }
                            )}
                        />
                        <label className="text-3xl md:text-xl ml-6 xl:text-xs">{translate(contents, 'label', lang)}</label>
                    </div>)
                break;
            case 'textarea':
                setContent(<div className="my-10 md:my-8">
                    <label className="text-4xl md:text-xl xl:text-xs">
                        {translate(contents, 'label', lang)}
                        {contents.required ? <span className="text-red float-right">*</span> : ''}
                    </label>
                    <textarea placeholder={translate(contents, 'placeHolder', lang)} name={contents.name}
                        className="mt-2 w-full text-grey-darkest shadow-sm h-36 text-3xl md:text-xl xl:text-xs p-4"
                        {...register(
                            contents.name == 'detail' ? 'detail' : 'none', {
                                ...requiredRule(contents.required, contents.placeHolder, lang, {
                                    possessive: false,
                                    lowercase: false,
                                }),
                            }
                        )}
                    >
                    </textarea>
                </div>)
                break;
            case 'text':
                setContent(
                <div className="my-10 md:my-8 relative text-left">
                    <label className="text-4xl md:text-xl xl:text-xs">
                        {translate(contents, 'label', lang)}
                        {contents.required ? <span className="text-red">*</span> : ''}
                    </label>
                    <input
                        className={`mt-2 rounded-md bg-white border-none lg:shadow-sm border-gray-300 py-2 px-3 text-grey-darkest h-20 lg:h-12 w-full text-3xl md:text-xl xl:text-xs`}
                        name={contents.name}
                        type="text"
                        placeholder={translate(contents, 'placeHolder', lang)}
                        {...register( 
                            contents.name == 'name' ? 'name' : 
                            contents.name == 'company_name' ? 'company_name' : 
                            contents.name == 'job' ? 'job' :
                            contents.name == 'email' ? 'email' :
                            contents.name == 'phoneNumber' ? 'phoneNumber' : 'none', {
                                ...requiredRule(contents.required, translate(contents, 'label', lang), lang),
                                ...formatRules(contents.name, lang),
                            }
                        )}
                    />
                </div>)
                break;
            default:
        }

    }, [lang, disabled]);
    return <div className="px-12">
        {content}
    </div>
}

export default Input;
